var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["core-sayt.j2"] = require( "core-sayt.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/category-new-search.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "category/templates/category-new-search.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("searchUrl")) {
var t_4 = t_1.searchUrl;
} else {
cb(new Error("cannot import 'searchUrl'")); return;
}
context.setVariable("searchUrl", t_4);
output += "\n\n<div class=\"dom-new-search\">\n\n    <form novalidate action=\"";
output += runtime.suppressValue((lineno = 4, colno = 39, runtime.callWrap(t_4, "searchUrl", context, [])), env.opts.autoescape);
output += "\" class=\"js-site-search__form c-new-search__form\" method=\"get\">\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12 o-medium--8 s-new-search\">\n                \n                <input autocomplete=\"off\" autocapitalize=\"off\" type=\"search\" name=\"q\" class=\"c-new-search__input c-form__text js-site-search__input\" data-search-source=\"category\" placeholder=\"New Search\" aria-label=\"New Search\" />";
var t_5;
t_5 = "category";
frame.set("source", t_5, true);
if(frame.topLevel) {
context.setVariable("source", t_5);
}
if(frame.topLevel) {
context.addExport("source", t_5);
}
env.getTemplate("core-sayt.j2", false, "category/templates/category-new-search.j2", null, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
t_6.render(context.getVariables(), frame, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
output += t_7
output += "\n                    \n            </div>\n\n            <div class=\"o-column o-extra-small--12 o-medium--4\">\n\n                <button class=\"c-new-search__button c-button-primary\" type=\"submit\">";
output += runtime.suppressValue((lineno = 19, colno = 86, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_new-search-submit"])), env.opts.autoescape);
output += "</button>\n\n            </div>\n\n        </div>\n\n    </form>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/category-new-search.j2"] , dependencies)